import { useEffect, useState, lazy, Suspense } from "react";
import { useNavigate } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// import "../styles/Pages/Home.css";

const Introduction = lazy(() => import("../components/homePage/Introduction"));
const About = lazy(() => import("../components/homePage/About"));
const Achievements = lazy(() => import("../components/homePage/Achievements"));
const Specialties = lazy(() => import("../components/homePage/Specialties"));
const LatestArticles = lazy(() =>
  import("../components/homePage/LatestArticles")
);
const HeartCare = lazy(() => import("../components/homePage/HeartCare"));
const Contact = lazy(() => import("../components/homePage/Contact"));

export default function Home() {
  const navigate = useNavigate();
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    fetch("https://api-portfolio-arturo.vercel.app/post")
      .then((res) => res.json())
      .then((data) =>
        setPosts(
          data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
        )
      );
  }, []);

  useEffect(() => {
    AOS.init({ once: false, mirror: false });
  }, []);

  return (
    <div className='Home'>
      <Suspense fallback={<div>Loading...</div>}>
        <Introduction onArticlesClick={() => navigate("/articles")} />
        <About />
        <Achievements />
        <Specialties />
        <LatestArticles posts={posts.slice(0, 5)} />
        <HeartCare />
        <Contact onContactClick={() => navigate("/contact")} />
      </Suspense>
    </div>
  );
}
